<template>
    <div class="cell small-12 medium-6 large-4" >
        <div class="o-vacancies-filters__location-filter" :class="{ 'active' : activeFilters.location.value?.search !== null && activeFilters.location.value?.search !== '' }">
            <input type="text" name="location" :placeholder="$t('vacancies.location')" v-model="activeFilters.location.value.search"  @keyup="searchLocation()"/>
            <div class="o-vacancies-filters__location-toggle" >
                <i class="c-icon icon-search"></i>
            </div>
            <div class="o-vacancies-filters__location-error" v-if="locationError" v-html="locationError"></div>
        </div>
    </div>
    <div class="cell small-12 medium-6 large-4" v-if="filters.location_radius" >
        <div class="o-vacancies-filters__select-filter" :class="{ 'active' : isActiveFilter( 'location_radius' ), 'active open' : openFilter }">
            <span class="o-vacancies-filters__select-wrapper">
                <span v-html="selectLabel"></span>
                <div class="o-vacancies-filters__select-toggle" @click="toggleOpenFilter()">
                    <i class="c-icon icon-arrow-down-c"></i>
                </div>
            </span>
            <ul class="o-vacancies-filters__select-options" data-filter="location_radius">
                <li v-for="(item, item_key) in filters.location_radius" :key="item_key" class="c-vacancies-filter-option" :class="{ 'active' : isActiveFilterOption( 'location_radius', item_key ) }" @click="toggleFilters( 'location_radius', item_key )">
                    {{ item }}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import vacanciesMixin from "../../../mixins/vacancies";

    export default {
        name: 'LocationFilter',
        props: ['filters'],
        mixins: [vacanciesMixin],
        computed: {
            selectLabel(){
                let vm = this,
                    label = '';

                if( vm.activeFilters.location_radius.value !== null ) {
                    Object.keys(vm.filters.location_radius).forEach((filter, index) => {
                        if( filter === vm.activeFilters.location_radius.value ) {
                            label = vm.filters.location_radius[filter];
                        }
                    });
                } else {
                    label = vm.$t("vacancies.location_radius");
                }

                return label;
            }
        },
        methods: {
            getLatLng() {
                let vm = this,
                    geocoder;

                vm.$store.dispatch( 'updateLocationError', false );

                geocoder = new google.maps.Geocoder();

                geocoder.geocode( { 'address': vm.activeFilters.location.value.search }, function(results, status) {
                    if (status == 'OK') {
                        if( results[0].geometry.location_type == 'APPROXIMATE' ) {

                            const boundsLat = results[0].geometry.bounds.getNorthEast().lat() + ( ( results[0].geometry.bounds.getSouthWest().lat() - results[0].geometry.bounds.getNorthEast().lat() ) / 2 );
                            const boundsLng = results[0].geometry.bounds.getNorthEast().lng() + ( ( results[0].geometry.bounds.getSouthWest().lng() - results[0].geometry.bounds.getNorthEast().lng() ) / 2 );

                            vm.activeFilters.location.value.lat = boundsLat;
                            vm.activeFilters.location.value.lng = boundsLng;
                        }
                        else {
                            vm.activeFilters.location.value.lat = results[0].geometry.location.lat;
                            vm.activeFilters.location.value.lng = results[0].geometry.location.lng;

                            vm.activeFilters.location.value.lat = results[0].geometry.location.lat;
                            vm.activeFilters.location.value.lng = results[0].geometry.location.lng;
                        }
                    } else {
                        vm.activeFilters.location.value.lat = null;
                        vm.activeFilters.location.value.lng = null;

                        vm.$store.dispatch( 'updateLocationError', vm.$t('vacancies.no_location') );
                    }
                });
            },
            searchLocation() {
                let vm = this;

                clearTimeout(vm.typingTimer);

                if (vm.activeFilters.location.value.search !== '') {
                    vm.typingTimer = setTimeout(vm.getLatLng, vm.doneTypingInterval);
                }
            }
        },
        data() {
            return {
                openFilter: false,
                typingTimer: null,
                doneTypingInterval: 500
            }
        }
    }
</script>